"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@prismicio/react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _serializeHtml = _interopRequireDefault(require("./serializeHtml"));

var _Hyperlink = _interopRequireDefault(require("./components/Hyperlink"));

var _ListItem = _interopRequireDefault(require("./components/ListItem"));

var _OListItem = _interopRequireDefault(require("./components/OListItem"));

var _Span = _interopRequireDefault(require("./components/Span"));

var _EmbeddedVideo = _interopRequireDefault(require("./components/EmbeddedVideo"));

var _Image = _interopRequireDefault(require("./components/Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var PrismicHtmlSerializer = /*#__PURE__*/function (_Component) {
  _inherits(PrismicHtmlSerializer, _Component);

  var _super = _createSuper(PrismicHtmlSerializer);

  function PrismicHtmlSerializer(props) {
    var _this;

    _classCallCheck(this, PrismicHtmlSerializer);

    _this = _super.call(this, props);
    var baseClass = props.baseClass,
        options = props.options;
    _this.baseClass = baseClass;
    _this.serializeHtml = _serializeHtml["default"].bind(_assertThisInitialized(_this));
    _this.components = {
      'list-item': _ListItem["default"][options.listItem || 'default'],
      'o-list-item': _OListItem["default"][options.oListItem || 'default'],
      span: _Span["default"][options.span || 'default'],
      hyperlink: _Hyperlink["default"][options.hyperlink || 'default'],
      embed: _EmbeddedVideo["default"][options.embed || 'default'],
      image: _Image["default"][options.image || 'default']
    };
    return _this;
  }

  _createClass(PrismicHtmlSerializer, [{
    key: "render",
    value: function render() {
      var content = this.props.content;
      return /*#__PURE__*/_react["default"].createElement(_react2.PrismicRichText, {
        field: content,
        components: this.serializeHtml
      });
    }
  }]);

  return PrismicHtmlSerializer;
}(_react.Component);

PrismicHtmlSerializer.propTypes = {
  content: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  options: _propTypes["default"].shape({}),
  baseClass: _propTypes["default"].string
};
PrismicHtmlSerializer.defaultProps = {
  options: {},
  baseClass: ''
};
var _default = PrismicHtmlSerializer;
exports["default"] = _default;